// src/components/Footer.jsx
function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 sm:px-6 py-4 text-center text-gray-500 text-sm">
        © 2024 E-commerce Admin Panel. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
